// src/components/common/Title.tsx
import Link from 'next/link';
import AppImage from '../ui/AppImage';

export const Title = ({ primary = true, href = '/' }: { primary?: boolean; href?: string }) => {
  const titleColor = primary ? 'var(--color-primary-foreground)' : 'var(--color-primary)';
  // Tagline must stay legible on BOTH backgrounds. On the deep-green header/footer
  const taglineColor = primary ? 'var(--color-secondary)' : 'var(--color-accent)';
  return (
    <Link
      href={href}
      className="flex items-center group transition-opacity duration-300 hover:opacity-80"
    >
      <AppImage
        className="pt-2 mr-1"
        width={40}
        height={40}
        src={'/assets/images/logo.png'}
        priority
        alt={'Flora dine logo'}
      />
      <svg
        width="200"
        height="45"
        viewBox="0 0 200 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="transition-transform duration-300 group-hover:scale-105"
      >
        <text
          x="0"
          y="28"
          fontFamily="Playfair Display"
          fontSize="25"
          fontWeight="800"
          fill={titleColor}
          letterSpacing="0.05em"
        >
          FLORA DINE
        </text>
        <text
          x="0"
          y="40"
          fontFamily="Inter"
          fontSize="11"
          fontWeight="700"
          fill={taglineColor}
          letterSpacing="0.02em"
        >
          Purely Natural, Truly Disposable
        </text>
      </svg>
    </Link>
  );
};
